import { canUseDOM } from '../../helpers/canUseDOM';
import { isIOS } from '../../helpers/isIOS';
import * as StandartScrollLocker from './StandartScrollLocker';
import * as TouchScrollLocker from './TouchScrollLocker';
function ensureElement(element) {
  if (typeof window !== 'undefined') {
    return element || document.body;
  }
  return null;
}

/**
 * Добавляет запрет на прокрутку содержимого на DOM-элементе.
 *
 * @param container Ссылка на DOM-элемент. По-умолчанию: `document.body`
 */
export function lock(container) {
  if (!canUseDOM()) {
    return;
  }
  const element = ensureElement(container);
  if (element === null) {
    return;
  }
  StandartScrollLocker.lock(element);
  if (isIOS()) {
    TouchScrollLocker.lock(element);
  }
}

/**
 * Убирает запрет на прокрутку содержимого на DOM-элементе.
 *
 * @param container Ссылка на DOM-элемент. По-умолчанию: `document.body`
 */
export function unlock(container) {
  if (!canUseDOM()) {
    return;
  }
  const element = ensureElement(container);
  if (element === null) {
    return;
  }
  StandartScrollLocker.unlock(element);
  if (isIOS()) {
    TouchScrollLocker.unlock(element);
  }
}